import { render, staticRenderFns } from "./reporteestudiante.vue?vue&type=template&id=05ba30e6"
import script from "./reporteestudiante.vue?vue&type=script&lang=js"
export * from "./reporteestudiante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports